export default {
  "rtl": "GAnby",
  "ltr": "SI1sR"
};